import Vue from 'vue';
import RecentArticles from './RecentArticles.vue';

window.initRecentArticles = (el, options) => {
	new Vue({
		el,
		render: h => h(RecentArticles, {
			props: options,
		}),
	});
};
